<script>
  import VueElementLoading from 'vue-element-loading'
  import formatDateMixin from '@mixins/FormatDateMixin.vue'
  import { pluralizeMethods } from '@state/helpers'

  export default {
    components: {
      VueElementLoading,
    },
    mixins: [formatDateMixin],
    model: {
      prop: 'value',
    },
    props: {
      value: {
        type: null,
        default: null
      },
      finishedLoading: {
        type: Boolean,
        required: true
      },
      type: {
        type: String,
        default: 'Document'
      },
      extraClasses: {
        type: String,
        default: ''
      },
      bgColour: {
        type: String,
        default: 'bg-col-gray-2'
      },
    },
    data() {
      return {
        expanded: false,
        collapsed: true,
        collapsedHeight: 0,
      }
    },
    watch: {
      expanded(newVal, oldVal){
        if (newVal === true){
          this.$nextTick(() => this.$set(this, 'collapsed', false));
        } else {
          this.$set(this, 'collapsed', true)
        }
      },
      finishedLoading(newVal, oldVal){
        if (newVal === true){
          this.updateCollapsedHeight()
        }
      }
    },
    mounted(){
      this.updateCollapsedHeight()
    },
    methods: {
      ...pluralizeMethods,
      toggleExpanded(){
        this.expanded = !this.expanded;
      },
      updateCollapsedHeight(){
        this.$nextTick(() => {
          if (this.$refs.historyWrapper && this.$refs.historyWrapper.clientHeight){
            this.collapsedHeight = this.$refs.historyWrapper.clientHeight
          }
        });
      }
    }
  }
</script>

<template>
  <section>
    <section v-if="value && value.length > 0" class="fl-columns border border-radius-20" :class="bgColour">
      <section class="hr-solid-line">
        <div class="fl-left-right mg-xy-20" :class="bgColour">
          <div :class="bgColour">
            <span class="tx-col-black">{{type}} history ({{value.length}} {{pluralize( 'item', value.length )}})</span>
          </div>
          <div 
            v-if="value.length > 5" 
            class="curs-p !tw-bg-u"
            @click="toggleExpanded">
            <BaseChevronRotate
              transition-class="rotate-360-180"
              size="1.2x"
              default-collapsed
              :toggle="!expanded"
              :duration="500"
              class="tw-text-black group-hover:tw-text-white"
            />
          </div>
        </div>
      </section>
      <FabricTransitionHeight
        :height="collapsedHeight"
        :duration="500">
        <div 
          v-show="!collapsed"
          ref="historyWrapper"
          v-bind="$attrs" 
          :class="[
            'pd-t-15 pd-b-10 border-radius-b-20 !tw-block', 
            bgColour, 
            extraClasses]">
          <BaseTimelineItem
            v-for="(history, index) in value"
            :key="`history-${index}`"
            :lines="history.lines"
            :navs="history.navigate_params"
            :uid="history.id"
            :background-colour="bgColour"
            :expanded="expanded"
            :my-index="index"
            :my-index-last="value.length - 1"
            @set-expanded="expanded = true"
          />
        </div>
      </FabricTransitionHeight>
    </section>
    <section v-else-if="!finishedLoading" class="f-h-210">
      <VueElementLoading :active="!(value && value.length > 0)" spinner="bar-fade-scale" />
    </section>
  </section>
</template>
